<section class="header_area">
    <div class="header_navbar">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <nav class="navbar navbar-expand-lg">
                        <a class="navbar-brand mx-4" href="https://www.bdatasolutions.com/redthread/" target="_blank">
                            <img src="assets/img/RT-Fit.png" alt="Red Thread Fit">
                        </a>
                        <button class="navbar-toggler" type="button" data-toggle="collapse"
                                data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                aria-expanded="false" aria-label="Toggle navigation">
                            <ng-container>
                                <ul id="nav" class="navbar-nav ml-auto">
                                    <li class="nav-item active">
                                        <a class="page-scroll" [routerLink]="['/extra-layout/signin']" selected
                                            [hidden]="disableSignIn">Sign In</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="page-scroll" [routerLink]="['/extra-layout/home']" selected
                                            [hidden]="disableHome">Home</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="page-scroll" href="https://www.bdatasolutions.com/resources/"
                                           selected target="_blank">
                                            Resources
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="page-scroll" href="https://www.bdatasolutions.com/contact/"
                                           selected target="_blank">
                                            Contact Us
                                        </a>
                                    </li>
                                </ul>
                            </ng-container>
                        </button>

                        <div class="collapse navbar-collapse sub-menu-bar" id="navbarSupportedContent">
                            <ul id="nav" class="navbar-nav ml-auto mr-5">
                                <ng-template #elseBlock>
                                    <li class="nav-item active">
                                        <a class="page-scroll" [routerLink]="['/extra-layout/signin']" selected
                                           [hidden]="disableSignIn">
                                            Sign In
                                        </a>
                                    </li>
                                    <li class="nav-item ml-3">
                                        <a class="page-scroll" [routerLink]="['/extra-layout/home']" selected
                                           [hidden]="disableHome">
                                            Home
                                        </a>
                                    </li>
                                    <li class="nav-item ml-3">
                                        <a class="page-scroll" href="https://www.bdatasolutions.com/resources/"
                                           target="_blank">
                                            Resources
                                        </a>
                                    </li>
                                    <li class="nav-item ml-3">
                                        <a class="page-scroll" href="https://www.bdatasolutions.com/contact/"
                                           target="_blank">
                                            Contact Us
                                        </a>
                                    </li>
                                </ng-template>
                                <div class="nav-item dropdown" *ngIf="signedInUserName; else elseBlock">
                                    <button mat-raised-button color="primary"
                                            [routerLink]="['/default-layout/dashboard']" selected>
                                        {{signedInUserName}}
                                    </button>
                                    <button mat-raised-button color="warn" class="ml-3"
                                            [routerLink]="['/extra-layout/signout']" selected>
                                        Sign Out
                                    </button>
                                </div>
                            </ul>
                        </div> <!-- navbar collapse -->
                    </nav> <!-- navbar -->
                </div>
            </div> <!-- row -->
        </div> <!-- container -->
    </div> <!-- header navbar -->
</section>